<template lang="html">
  <div id="data-list-list-view" class="data-list-container">
    <vx-card title="Nid Validated Applicant">
      <template slot="actions">
        <vx-input-group class="mb-base">
          <vs-input class="w-full" placeholder="Enter Nid No" @keypress="onlyNumber"
                    v-model="searchParam"/>
          <template slot="append">
            <div class="append-text btn-addon">
              <vs-button color="primary" icon-pack="feather" icon="icon-search"
                         @click="serachActiveApplicant(searchParam)"></vs-button>
            </div>
          </template>
        </vx-input-group>
      </template>
      <vs-table stripe
                :sst="true"
                @change-page="handleChangePage"
                v-model="selected"
                :total="allUser.total"
                pagination
                :max-items="allUser.per_page"
                :data="allUser.data">
        <template slot="thead">
          <vs-th sort-key="name">
            Name
          </vs-th>
          <vs-th>
            Nid No.
          </vs-th>
          <vs-th sort-key="nid">
            Fathers Name
          </vs-th>
          <vs-th sort-key="status">
            Date Of Birth
          </vs-th>
          <vs-th sort-key="id">
            Action
          </vs-th>
        </template>

        <template slot-scope="{data}">
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td :data="data[indextr].name">
              {{data[indextr].name}}
            </vs-td>

            <vs-td :data="data[indextr].nid_no">
              {{data[indextr].nid_no}}
            </vs-td>

            <vs-td :data="data[indextr].fathers_name">
              {{data[indextr].fathers_name}}
            </vs-td>

            <vs-td :data="data[indextr].date_of_birth">
              {{data[indextr].date_of_birth}}
            </vs-td>


            <vs-td class="whitespace-no-wrap">
              <div class="demo-alignment">
                <feather-icon icon="EyeIcon" @click="applicantDetal(data[indextr].nid_no)"
                              svgClasses="w-5 h-5 hover:text-success stroke-current"
                              class="ml-2 clickable"/>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
<!--      <button @click="add">Update Address</button>-->
    </vx-card>
    <template lang="html">
      <div class="centerx">
        <vs-popup class="holamundo" title="Applicant Details" :active.sync="popupActivo">
          <vx-card>
            <div>
              <div >
                <img :src="singleUser.nid_photo" height="150px" alt="" style="border-radius: 3px; margin-bottom: 15px">
              </div>
              <table class="user-table">
                <tbody>
                <tr>
                  <th>Applicant Name</th>
                  <td>{{singleUser.name}}</td>
                </tr>
                <tr>
                  <th>Applicant Name Bangla</th>
                  <td>{{singleUser.name_bangla}}</td>
                </tr>
                <tr>
                  <th>Fathers Name</th>
                  <td>{{singleUser.fathers_name}}</td>
                </tr>
                <tr>
                  <th>Fathers Name Bangla</th>
                  <td>{{singleUser.fathers_name_bangla}}</td>
                </tr>
                <tr>
                  <th>Mothers Name</th>
                  <td>{{singleUser.mother_name}}</td>
                </tr>
                <tr>
                  <th>Mothers Name Bangla</th>
                  <td>{{singleUser.mother_name_bangla}}</td>
                </tr>
                <tr>
                  <th>Nid No.</th>
                  <td>{{singleUser.nid_no}}</td>
                </tr>
                <tr>
                  <th>Nid No. Old</th>
                  <td>{{singleUser.old_nid_no}}</td>
                </tr>
                <tr>
                  <th style="color: #ea5455">13 Digit Nid Issue Resolver</th>
                  <td>
                    <div class="demo-alignment">

                      <vs-input disabled type="text" v-model="singleUser.old_nid_no"></vs-input>
                      <vs-input type="text" placeholder="Enter Nid No" v-model="thirteen_d_nid_no"></vs-input>
                      <vs-button color="primary" :disabled="!thirteen_d_nid_no"
                                 @click="fixThirteeenDigitNid(singleUser.old_nid_no, thirteen_d_nid_no)">Fix</vs-button>
                    </div>

                  </td>
                </tr>
                <tr>
                  <th>Present Address</th>
                  <td>{{singleUser.present_address}}</td>
                </tr>
                <tr>
                  <th>Present Address Bangla</th>
                  <td>{{singleUser.present_address_bangla}}</td>
                </tr>
                <tr>
                  <th>Permanent Address</th>
                  <td>{{singleUser.permanent_address}}</td>
                </tr>
                <tr>
                  <th>Permanent Address Bangla</th>
                  <td>{{singleUser.permanent_address_bangla}}</td>
                </tr>
                <tr>
                  <th>Date Of Birth</th>
                  <td>{{singleUser.date_of_birth}}</td>
                </tr>
                <tr>
                  <th>Gender</th>
                  <td>{{singleUser.gender}}</td>
                </tr>
                <tr>
                  <th>Profession</th>
                  <td>{{singleUser.profession}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </vx-card>
        </vs-popup>
      </div>
    </template>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import axios from "../axios";

export default {
  data() {
    return {
      selectedPgae: 1,
      searchParam: '',
      selected: [],
      popupActivo: false,
      popupActivForDelete: false,
      mobile: '',
      selectedId: '',
      selectedUser: '',
      allUser:[],
      singleUser:[],
      thirteen_d_nid_no:''
    }
  },
  computed: {

  },
  mounted() {
    axios.get(`https://ho.butterflygroupbd.com/showroom-backend/api/allNidValidatedApplicant`).then(res => {
      this.allUser = res.data;
    })
  },
  watch: {
    searchParam(value) {
      if (value.length < 1) {
        axios.get(`https://ho.butterflygroupbd.com/showroom-backend/api/allNidValidatedApplicant`).then(res => {
          this.allUser = res.data;
        })
      }
    }
  },
  methods: {
/*     add(){
      let adress = []
       adress.forEach((id) => {
        axios.put(`https://ho.butterflygroupbd.com/showroom-backend/api/nidAddressCgange/${id}`).then(adds =>{
          console.log(new Date(), adds)
        });
      })
    },*/



    handleChangePage(page) {
      this.selectedPgae = page;
      axios.get(`https://ho.butterflygroupbd.com/showroom-backend/api/allNidValidatedApplicant?page`+ this.selectedPgae).then(res => {
        this.allUser = res.data;
      })
    },
    applicantDetal(nid) {
      this.popupActivo = true;
      this.singleUser= [];
      axios.get(`https://ho.butterflygroupbd.com/showroom-backend/api/getNidInfoByNidNo/${nid}`).then(res => {
        this.singleUser = res.data;
      })
      // this.$router.push('/applicant-details/' + id).catch(() => {
      // })
    },
    fixThirteeenDigitNid(oldNid, thirteenDNid){
      if(thirteenDNid){
        axios.put(`https://ho.butterflygroupbd.com/showroom-backend/api/updateValidNidInfo/${thirteenDNid}/${oldNid}`).then(upres =>{
          if(upres.data === "validate"){
            this.$vs.notify({
              title: 'Success!',
              text: 'Successfully Fixed.',
              color: 'success',
              position: 'top-right'
            })
          }else {
            this.$vs.notify({
              title: 'Error!',
              text: 'Something went wrong.',
              color: 'danger',
              position: 'top-right'
            })
          }

        })
      }
    },

    serachActiveApplicant(nid) {
      axios.get(`https://ho.butterflygroupbd.com/showroom-backend/api/allNidValidatedApplicantByNid/${nid}`).then(res => {
        this.allUser = res.data;
      })
    },

    onlyNumber($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which)
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
        $event.preventDefault()
      }
    },
  }
}
</script>
